// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611040435/js/" + chunkId + "." + {"44":"9239fa42","225":"e569aa8b","481":"34aec01f","486":"7e80b32b","770":"08926b44"}[chunkId] + ".0.7726458582200265.chunk.js";
};